import { z } from 'zod';

export type ReceiptEventType = 'Receipt_RefundRequest_Success'
  | 'Receipt_RefundRequest_Error';

// Receipt event payload schemas
export const RequestRefundActionPayloadSchema = z.object({
  // order_id: z.string(), // GDPR: Temporarily removed for privacy compliance
  locale: z.string(),
  reseller: z.string().optional(),
  product_type: z.string().optional(),
  billing_type: z.string().optional(),
  response_code: z.string().optional(),
  response_message: z.string().optional(),
});

export type ReceiptEventTypePayloadMap = {
  Receipt_RefundRequest_Success: z.infer<typeof RequestRefundActionPayloadSchema>;
  Receipt_RefundRequest_Error: z.infer<typeof RequestRefundActionPayloadSchema>;
};

export const ReceiptEventSchemaMap = {
  Receipt_RefundRequest_Success: RequestRefundActionPayloadSchema,
  Receipt_RefundRequest_Error: RequestRefundActionPayloadSchema,
};
